import e, { Component as t } from "react";
import { TextFieldValidated as r } from "./TextFieldValidated.js";
function n(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function o(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function i(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function c(e) {
  return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function u(e, t) {
  return (u = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var l = [],
  a = function a() {
    return l.reduce(function (e, t) {
      return e && (null == t ? void 0 : t.validate());
    }, !0);
  },
  f = function (t) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && u(e, t);
    }(y, t);
    var a,
      f,
      s,
      p = (a = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
          t,
          r = c(y);
        if (a) {
          var o = c(this).constructor;
          t = Reflect.construct(r, arguments, o);
        } else t = r.apply(this, arguments);
        return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : n(this);
      });
    function y() {
      var e;
      return !function (e, t) {
        if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
      }(this, y), e = p.apply(this, arguments), i(n(e), "textfield", void 0), i(n(e), "state", {
        reveal: !1
      }), i(n(e), "componentDidMount", function () {
        return l.push(n(e));
      }), i(n(e), "componentWillUnmount", function () {
        return l = l.filter(function (t) {
          return t !== n(e);
        });
      }), i(n(e), "_toggleReveal", function () {
        var t, r;
        null === (t = (r = e.props).onToggleReveal) || void 0 === t || t.call(r, !e.state.reveal), e.props.disabled || e.setState({
          reveal: !e.state.reveal
        });
      }), i(n(e), "focus", function () {
        var t;
        return null === (t = e.textfield) || void 0 === t ? void 0 : t.focus();
      }), i(n(e), "validate", function () {
        var t;
        return null === (t = e.textfield) || void 0 === t ? void 0 : t.validate();
      }), i(n(e), "_receiveRef", function (t) {
        return e.textfield = t;
      }), e;
    }
    return f = [{
      key: "render",
      value: function value() {
        var t, n;
        return e.createElement(r, (t = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {},
              n = Object.keys(r);
            "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
              return Object.getOwnPropertyDescriptor(r, e).enumerable;
            }))), n.forEach(function (t) {
              i(e, t, r[t]);
            });
          }
          return e;
        }({}, this.props), n = n = {
          ref: this._receiveRef,
          reveal: this.state.reveal,
          onToggleReveal: this._toggleReveal
        }, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : function (e, t) {
          var r = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            r.push.apply(r, n);
          }
          return r;
        }(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        }), t));
      }
    }], o(y.prototype, f), s && o(y, s), y;
  }(t);
i(f, "displayName", "StatefulTextField"), i(f, "Stateless", r);
export { f as TextField, a as validateAllInstances };